import React from "react";
import { RCCModal, RCCRefModalProps, RCCGrid } from "react-common-components";
import { css } from "styled-components";
import { useTranslation } from "src/context/Translations/context";
import IDeleteModal from "./interface";

const DeleteModal: React.ForwardRefRenderFunction<RCCRefModalProps, IDeleteModal> = ({title,description,height,isInfo = false,children, withoutForm, ...rest}, ref) => {
	const { translate } = useTranslation();
	return (
		<RCCModal
			ref={ref}
			header={{
				title,
				icon: {
					name: isInfo ? "infoCircle" : "trash"
				}
			}}
			footer={{
				buttonLoadingText:translate("Carregando"),
				saveButtonText:translate("Sim"),
				cancelButtonText:translate("Não"),
				showSaveButton:true
			}}
			styleInline={css`
                width: 50vw;
                min-width: 300px;
                height: ${height||"180px"};
                position: absolute;
                top: 60px;
            `}
			withoutForm={withoutForm}
			{...rest}
		>
			<RCCGrid
				container
				item
				justifyContent="center"
				direction="column"
			>
				<h4>
					{description}
				</h4>
			</RCCGrid>
			{children}
		</RCCModal>
	);
};

export default React.forwardRef(DeleteModal);

